import React, {useEffect, useRef} from 'react';
import {Animated, StyleSheet, View} from 'react-native';

const Bone: React.FC<{
  width: number | string;
  height: number;
  style?: object;
  borderRadius?: number;
}> = ({width, height, style, borderRadius = 6}) => {
  const opacity = useRef(new Animated.Value(0.4)).current;

  useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: 1,
          duration: 700,
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          toValue: 0.4,
          duration: 700,
          useNativeDriver: true,
        }),
      ]),
    );
    animation.start();
    return () => animation.stop();
  }, [opacity]);

  return (
    <Animated.View
      style={[
        {
          width,
          height,
          backgroundColor: '#E5E7EB',
          borderRadius,
          opacity,
        },
        style,
      ]}
    />
  );
};

const ShiftClaimSkeleton: React.FC = () => (
  <View style={styles.container}>
    <View style={styles.card}>
      <Bone width="65%" height={28} style={styles.gap} />
      <Bone width="45%" height={18} style={styles.gap} />

      <View style={styles.divider} />

      {[0, 1, 2].map(i => (
        <View key={i} style={styles.row}>
          <Bone width={80} height={13} style={styles.gapSm} />
          <Bone width={160} height={18} />
        </View>
      ))}
    </View>

    <Bone width="100%" height={54} borderRadius={12} />
  </View>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    maxWidth: 480,
    alignSelf: 'center',
    width: '100%',
  },
  card: {
    backgroundColor: '#FAFAFA',
    borderRadius: 16,
    padding: 20,
    marginBottom: 24,
  },
  gap: {marginBottom: 12},
  gapSm: {marginBottom: 6},
  divider: {
    height: 1,
    backgroundColor: '#E5E7EB',
    marginVertical: 16,
  },
  row: {
    marginBottom: 16,
  },
});

export default React.memo(ShiftClaimSkeleton);
